const ManagementAlertsSubcategory = () => {
  return (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_2496_3623)" />
      <path d="M19.0098 32.9291H22.7723V34.7906H19.0098V32.9291Z" fill="white" />
      <path d="M33.9744 21.7325V18H35.8071V21.7325H33.9744Z" fill="white" />
      <path
        d="M26.9424 24.6359C26.5262 25.052 26.097 25.481 25.6896 25.8883C24.8473 25.0463 23.9801 24.1793 23.1365 23.3361C23.5322 22.94 23.9666 22.5053 24.3884 22.0831C25.2234 22.9177 26.0914 23.7853 26.9424 24.6361V24.6359Z"
        fill="white"
      />
      <path
        d="M45.4484 22.0905C45.8361 22.4788 46.2651 22.9081 46.6733 23.3169C45.8215 24.1645 44.9486 25.0329 44.0891 25.888C43.7027 25.5003 43.2748 25.0709 42.8706 24.6654C43.7199 23.817 44.5911 22.9467 45.4482 22.0905H45.4484Z"
        fill="white"
      />
      <path
        d="M34.9137 36.6536C35.4256 36.6598 35.8281 37.069 35.8279 37.5827C35.8277 38.1086 35.4108 38.5187 34.8827 38.5122C34.36 38.5058 33.9564 38.0814 33.969 37.5515C33.9812 37.0434 34.398 36.6471 34.9139 36.6534L34.9137 36.6536Z"
        fill="white"
      />
      <path
        d="M40.0762 47.1247C39.6702 46.1653 39.4276 45.1578 39.3518 44.1213H22.7798V47.8983H20.9336V49.7452H41.7321C41.0394 48.9667 40.4834 48.0873 40.0762 47.1247Z"
        fill="white"
      />
      <path
        d="M40.0764 39.6994C40.5568 38.5634 41.2441 37.5436 42.1193 36.6684C42.7022 36.0855 43.3492 35.5862 44.0518 35.1755C44.0005 34.7195 43.9494 34.2634 43.8989 33.8074C43.6847 31.8783 43.4795 29.9481 43.2591 28.0198C43.2458 27.9036 43.1548 27.7742 43.0628 27.693C42.4609 27.1613 41.7689 26.7743 41.0276 26.4719C39.5675 25.8764 38.0358 25.6273 36.4722 25.5318C34.5564 25.4148 32.6495 25.4691 30.7656 25.8678C29.3063 26.1767 27.9269 26.6808 26.7724 27.6658C26.6485 27.7715 26.5523 27.9647 26.5321 28.1284C26.3843 29.3272 26.2598 30.5289 26.1268 31.7294C25.9697 33.1454 25.8117 34.5613 25.6535 35.9773C25.4976 37.3727 25.3407 38.7679 25.1853 40.1634C25.11 40.8399 25.037 41.5166 24.9607 42.2133H33.9662C33.9662 41.6435 33.9554 41.0963 33.9711 40.5496C33.9781 40.3076 33.9221 40.1764 33.6782 40.0615C32.46 39.488 31.8609 38.1423 32.2159 36.8497C32.5656 35.5767 33.8 34.6915 35.0756 34.7991C36.3482 34.9064 37.3947 35.8138 37.6273 37.0115C37.8793 38.3094 37.2662 39.5234 36.0532 40.1011C35.8928 40.1776 35.8205 40.2542 35.8256 40.441C35.8398 40.9576 35.8296 41.4748 35.8316 41.9917C35.832 42.0699 35.8462 42.148 35.8536 42.2205H39.3996C39.5075 41.3536 39.7338 40.5097 40.0764 39.6997V39.6994Z"
        fill="white"
      />
      <path
        d="M51.1816 33.5043V33.9323C51.1816 34.2217 50.9489 34.4554 50.6631 34.4554H50.4817V35.2941C48.7004 34.9224 47.1706 35.2941 47.1706 35.2941V34.4554H46.9892C46.7038 34.4554 46.4705 34.2219 46.4705 33.9323V33.5043C46.4705 33.2149 46.7038 32.9856 46.9892 32.9856H50.6635C50.9489 32.9856 51.1816 33.2149 51.1816 33.5043Z"
        fill="white"
      />
      <path
        d="M55.4011 36.5806L53.0697 34.9513C52.9261 34.8512 52.8307 34.9121 52.7804 34.9682L52.7388 35.0281L52.1565 35.8613C52.1565 35.8613 53.6261 36.4353 54.8733 37.7595L55.4588 36.9214C55.5926 36.7275 55.4189 36.5935 55.4011 36.5804V36.5806Z"
        fill="white"
      />
      <path
        d="M48.8265 35.8715C44.6486 35.8715 41.2622 39.258 41.2622 43.4359C41.2622 47.6138 44.6487 51.0002 48.8265 51.0002C53.0042 51.0002 56.3902 47.6131 56.3902 43.4359C56.3902 39.2588 53.0036 35.8715 48.8265 35.8715ZM48.8265 43.4359V37.4536C48.8265 37.4536 54.4454 37.3598 54.8084 43.4359C50.7705 43.4229 48.8265 43.4359 48.8265 43.4359Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2496_3623"
          x1="34.5455"
          y1="2.70945e-07"
          x2="34.5455"
          y2="70"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#7000FF" />
          <stop offset="1" stop-color="#45009C" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default ManagementAlertsSubcategory
